import { memo, useMemo } from 'react';
import { ReactLink } from '@dfl/react-security';
import { Stack, Typography } from '@mui/material';
import { CouponIcon } from 'components/libs/Icons';

type Props = {
  value: string;
  record: any;
};

const OfferNameCell = ({ value, record }: Props) => {
  const name = useMemo(
    () => (
      <Typography className={'truncate'} title={value} maxWidth={400}>
        {value}
      </Typography>
    ),
    [value],
  );

  const route = useMemo(() => {
    if (record?.isCoupon) return `/sales/offers/settings/coupons/${record?._id as string || record?.offerId as string}/general`;
    return `/sales/offers/settings/offer_orders/${record?._id as string || record?.offerId as string}/general`;
  }, [record?.isCoupon, record?._id, record?.offerId]);

  return (
    <Stack direction={'row'} alignItems={'center'} spacing={1}>
      {record?.isCoupon && <CouponIcon color='primary' fontSize='small' />}
      <ReactLink to={route} underline={'hover'}>
        {name}
      </ReactLink>
    </Stack>
  );
};

export default memo(OfferNameCell);
